module.exports = __webpack_public_path__ + "img/04aa80be9c9e4a3b260dd1fca0a95c62.png";